import { gsap } from 'gsap';

// SECTION 04「みんなのAction!」の人物・果物の出現。
// 起点は __scene に付いた data-observe。observer.js が is-visible を付けるとき
// 同じ要素に observe:visible を飛ばすので、それを1回だけ拾って再生する。
// 見出し・カード・コメントはCSSキーフレーム側が持っている（_report.scss）。

// __comment のフェード（.6s）ぶん待ってから始める。
// 同じバッチで交差しても「コメントが先」に見える最小の間
const START_DELAY = .6;
// 人物が上がりきる前に果物を重ね始める
const FRUIT_OFFSET = .15;

const actionScene = {
  init() {
    const section = document.querySelector('.p-reportAction');
    if (!section) return;

    const trigger = section.querySelector('.p-reportAction__scene');
    if (!trigger) return;

    const person = section.querySelector('.p-reportAction__person');
    const fruits = gsap.utils.toArray(section.querySelectorAll('.p-reportAction__fruit'));
    if (!person && fruits.length === 0) return;

    const targets = person ? [person, ...fruits] : fruits;

    // 動きを減らす設定のときは最終状態だけ作って終わり。
    // scale / y は書かない（恒等 transform をインラインに残しても得が無い）
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      gsap.set(targets, { opacity: 1 });
      return;
    }

    let played = false;
    const play = () => {
      if (played) return;
      played = true;

      const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

      if (person) {
        // TODO(暫定値): ブラウザ確認後に詰める
        tl.fromTo(person,
          { opacity: 0, y: 24 },
          { opacity: 1, y: 0, duration: .5 },
          START_DELAY
        );
      }

      if (fruits.length) {
        // from: 'random' なので開くたびに順番が変わる（ユーザー指示）
        tl.fromTo(fruits,
          { opacity: 0, scale: .3 },
          { opacity: 1, scale: 1, duration: .45, stagger: { each: .09, from: 'random' } },
          START_DELAY + FRUIT_OFFSET
        );
      }
    };

    trigger.addEventListener('observe:visible', play, { once: true });

    // observer.js が先に発火し終えていた場合の保険。
    // played フラグがあるので二重再生にはならない
    if (trigger.classList.contains('is-visible')) play();
  }
}

export default actionScene;
